import { createSelector } from '@ngrx/store';
import { OrderData } from '@zero/shared/util-models';
import { orderFeature, OrderState } from './order.reducers';

export const selectOrderState = (category: keyof OrderState) =>
  createSelector(orderFeature.selectOrderState, (orderState) => orderState[category]);

export const selectOrders = (category: keyof OrderState) =>
  createSelector(selectOrderState(category), (state) => Object.values(state.entities).sort((a, b) => sortOrdersByCategory(a, b, category)));

export const selectOrderLoading = (category: keyof OrderState) => createSelector(selectOrderState(category), (state) => state.loading);
export const selectOrderHasNext = (category: keyof OrderState) => createSelector(selectOrderState(category), (state) => state.hasNext);
export const selectOrderInitiallyLoaded = (category: keyof OrderState) =>
  createSelector(selectOrderState(category), (state) => state.initiallyLoaded);

export const selectOrderISINsByCategory = (category: keyof OrderState) =>
  createSelector(selectOrders(category), (orders) => orders.map((order) => order.isin));

export const selectOrderByCategoryAndId = (category: keyof OrderState, orderId: string) =>
  createSelector(selectOrderState(category), (state) => state.entities[orderId]);

const sortOrdersByCategory = (a: OrderData, b: OrderData, category: keyof OrderState) => {
  if (category === 'canceledOrders') {
    return new Date(b.cancelDate).getTime() - new Date(a.cancelDate).getTime();
  } else if (category === 'filledOrders') {
    return new Date(b.execDate).getTime() - new Date(a.execDate).getTime();
  } else {
    return new Date(b.openDate).getTime() - new Date(a.openDate).getTime();
  }
};
